module.exports = __webpack_public_path__ + "media/images/icon__info--white@3x-2afce81dc7423bbcbda1085819fa858f.png";